// src/components/landing/ListingGrid.tsx
import React from "react";
import { BrandListing } from "../../types/brandlistingsmodel";
import { ListingCard } from "./ListingCard";
import { Pagination } from "./Pagination";
import { PAGE_SIZE } from "../../utils/listingFormat";

function CardSkeleton() {
  return (
    <div className="animate-pulse overflow-hidden rounded-2xl border border-slate-200 bg-white">
      <div className="aspect-[4/3] w-full bg-slate-100" />
      <div className="space-y-2 p-4">
        <div className="h-3 w-1/3 rounded bg-slate-100" />
        <div className="h-4 w-2/3 rounded bg-slate-100" />
        <div className="h-3 w-1/2 rounded bg-slate-100" />
        <div className="mt-4 h-8 w-full rounded bg-slate-100" />
      </div>
    </div>
  );
}

export function ListingGrid({
  listings,
  isLoading,
  error,
  page,
  onPageChange,
}: {
  listings: BrandListing[];
  isLoading: boolean;
  error: string | null;
  page: number;
  onPageChange: (page: number) => void;
}) {
  const totalPages = Math.max(1, Math.ceil(listings.length / PAGE_SIZE));
  const start = (page - 1) * PAGE_SIZE;
  const pageItems = listings.slice(start, start + PAGE_SIZE);

  if (error) {
    return (
      <div className="rounded-2xl border border-dashed border-red-200 bg-red-50 py-16 text-center text-sm text-red-600">
        {error}
      </div>
    );
  }

  if (isLoading) {
    return (
      <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
        {Array.from({ length: 8 }).map((_, i) => (
          <CardSkeleton key={i} />
        ))}
      </div>
    );
  }

  if (listings.length === 0) {
    return (
      <div className="rounded-2xl border border-dashed border-slate-200 py-20 text-center text-slate-400">
        No spaces match those filters yet. Try widening your search.
      </div>
    );
  }

  return (
    <>
      <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
        {pageItems.map((listing) => (
          <ListingCard key={listing.id} listing={listing} />
        ))}
      </div>
      <Pagination page={page} totalPages={totalPages} onChange={onPageChange} />
    </>
  );
}